import type { Test } from '@/data'
import type { TestPayload } from './createTest'
import api from '..'

export async function updateTest(
  id: string,
  payload: Partial<TestPayload>,
): Promise<Test> {
  const res = await api.put(`/flow_experiments/${id}`, payload)
  return res.data.data
}
